/**
 * Triggers a file download using a hidden iframe approach.
 * The iframe is automatically removed from the DOM after the specified timeout
 * to prevent memory leaks.
 *
 * @param url - The URL of the file to download
 * @param cleanupTimeout - Time in ms before the iframe is removed (default: 60000)
 */
export const downloadFileViaIframe = (
  url: string,
  cleanupTimeout = 60000
): void => {
  const iframe = document.createElement("iframe");
  iframe.setAttribute("src", url);
  iframe.style.display = "none";
  document.body.appendChild(iframe);
  setTimeout(() => {
    iframe.remove();
  }, cleanupTimeout);
};
